import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useNavigate } from 'react-router-dom';
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

function CourseMaster() {


  const dispatch = useDispatch();
  useEffect(() => {
    fetchCourse();

    dispatch(updateNavbarHeading("Course Master"))
  }, [])

  const [Course, setCourse] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  const navigate = useNavigate();

  const columns = {
    Code: { text: "Code", visible: true },
    CourseName: { text: "Course Name", visible: true },
    Version: { text: "Version", align: "center", visible: true },
    Description: { text: "Description", visible: true },
    IsInActive: { text: "Active", align: "center", visible: true },
  };


  const fetchCourse = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}course-masters`);
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const cleanedData = response?.data?.data?.map((skill) => {
          // Create a DOMParser instance
          const parser = new DOMParser();
          // Parse the string as text/html to decode HTML entities
          const parsedVersion = parser.parseFromString(skill.Version || '', 'text/html').body.textContent || '';

          return {
            ...skill,
            Version: parsedVersion.trim(),
          };
        });
        setCourse(cleanedData);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };



  const handleAddForm = () => {
    navigate('/course-master/add');
  }
  const handleEdit = (id) => {
    navigate(`/course-master/add/${id.ID}`);
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={Course}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
      </div>

    </>
  );
}

export default CourseMaster;
